<template>
	<v-app-bar class="header" fixed app height="65" style="width: auto;">
        <div style="display: flex;width: 100%; justify-content: space-evenly;align-items: center;">
            <!-- >>> Drawer -->
            <v-btn
                style="margin-left: 5px !important"
                depressed
                elevation="1"
                min-width="0"
                @click="!$isDesktop() ? actn_set_Drawer(!get_shared_Drawer) : $emit('input', !value)">
                <v-icon v-if="value">
                    mdi-view-quilt
                </v-icon>

                <v-icon v-else>
                    mdi-dots-vertical
                </v-icon>
            </v-btn>
            <!-- <<< Drawer -->

            <v-toolbar-title class="hidden-sm-and-down">
                SunFlight
            </v-toolbar-title>

            <!-- >>> Filter TextField -->
            <v-text-field
                v-if="$isDesktop()"
                v-model="legOrFlightNo"
                style="margin-left: 60px;margin-top: 22px;max-width:250px;"
                label="e.g. BER, SR5484"
                class="sdr-custom-text-input"
                @change="onChange_filterFlights" />
            <!-- <<< Filter TextField -->


            <flights-core-explanation />

            <!-- >>> Filter TextField -->
            <v-switch
                v-if="$isDesktop()"
                v-model="showTooltip"
                style="margin-top: 26px;"
                class="ml-10"
                color="primary"
                label="Tooltip"
                @change="onChange_TooltipSwitch" />
            <!-- <<< Filter TextField -->

            <!-- >>> Filter TextField -->
            <v-switch
                v-if="$isDesktop()"
                v-model="fixFlightToAircraft"
                style="margin-top: 26px;"
                class="ml-10"
                color="primary"
                label="Fix to Aircraft"
                @change="onChange_TooltipFixFlightToAircraft" />
            <!-- <<< Filter TextField -->

            <v-spacer v-if="$isDesktop()" />

            <!-- >>> Zoom -->
            <v-menu
                open-on-hover
                top
                offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn style="margin-right:5px !important" depressed elevation="1" min-width="0" color="#ab3b7a" text v-on="on">
                        <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="onInput_zoomSlider(1)">
                        <v-list-item-title>Overview</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="onInput_zoomSlider(2)">
                        <v-list-item-title>24h</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="onInput_zoomSlider(3)">
                        <v-list-item-title>15m</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <!-- <<< Zoom -->

            <v-spacer v-if="$isDesktop()" />

            <!-- >>> Sdr-Component, Date Menue -->
            <v-btn v-if="$isDesktop()" :disabled="isDateForwardBackwardDisabled()" style="padding: 0 2px 0 4px !important;" class="sdr-custom-button-with-icon mt-1" min-width="0" text @click="onClick_dateBackwardsLong">
                <sup style="margin-right:-2px;font-size:0.85rem;">-{{ CONF_DAYS_BACKWARD_LONG }}</sup>
                <v-icon>mdi-chevron-double-left</v-icon>
            </v-btn>
            <v-btn v-if="$isDesktop()" :disabled="isDateForwardBackwardDisabled()" style="padding: 0 2px 0 4px !important;" class="sdr-custom-button-with-icon mt-1" min-width="0" text @click="onClick_dateBackwardsShort">
                <sup style="margin-right:-2px;font-size:0.85rem;">-{{ CONF_DAYS_BACKWARD_SHORT }}</sup>
                <v-icon color="primary">
                    mdi-chevron-left
                </v-icon>
            </v-btn>
            <sdr-flights-appbar-datemenue />
            <v-btn v-if="$isDesktop()" :disabled="isDateForwardBackwardDisabled()" style="padding: 0 4px 0 2px !important;" class="sdr-custom-button-with-icon mt-1" min-width="0" text @click="onClick_dateForwardsShort">
                <v-icon color="primary">
                    mdi-chevron-right
                </v-icon>
                <sup style="margin-left:-2px;font-size:0.85rem;">+{{ CONF_DAYS_FORWARD_SHORT }}</sup>
            </v-btn>
            <v-btn v-if="$isDesktop()" :disabled="isDateForwardBackwardDisabled()" style="padding: 0 4px 0 2px !important;" class="sdr-custom-button-with-icon mt-1" min-width="0" text @click="onClick_dateForwardsLong">
                <v-icon color="primary">
                    mdi-chevron-double-right
                </v-icon>
                <sup style="margin-left:-2px;font-size:0.85rem;">+{{ CONF_DAYS_FORWARD_LONG }}</sup>
            </v-btn>
            <!-- <<< Sdr-Component, Date Menue -->

            <v-spacer v-if="$isDesktop()" />

            <!-- >>> Sdr-Component, Reports Menue -->
            <sdr-flights-reports-menue />
            <!-- <<< Sdr-Component, Reports Menue -->

            <v-spacer v-if="$isDesktop()" />

            <!-- >>> Sdr-Component, Filter Menue -->
            <sdr-flights-appbar-filtermenue />
            <!-- <<< Sdr-Component, Filter Menue -->

            <v-spacer v-if="$isDesktop()" />

            <v-btn
                style="margin-left:5px !important"
                depressed elevation="1" min-width="0" color="#ab2b7a"
                @click="onClick_refreshFlights">
                <v-icon style="color: #ffffff !important;">
                    mdi-reload
                </v-icon>
            </v-btn>

            <!-- >>> Comes later ... -->
            <!-- <v-btn class="mt-1" text min-width="0" style="margin-left: 40px; margin-right: 0px;">
                <v-icon>
                    mdi-overscan
                </v-icon>
            </v-btn> -->
            <!-- <<< Comes later ... -->
        </div>
    </v-app-bar>
</template>

<script>
    import FilterMenue from './FilterMenue.vue';
    import DateMenue from './DateMenue.vue';
    import ReportsMenue from '../../../../shared/components/core/ReportsMenue';

    import { mapGetters, mapActions } from 'vuex';

    import { eventBus } from '../../../../../main';
    import dayjs from 'dayjs';

    import {
        CONF_DAYS_BACKWARD_LONG,
        CONF_DAYS_BACKWARD_SHORT,
        CONF_DAYS_FORWARD_LONG,
        CONF_DAYS_FORWARD_SHORT
    } from '../../../../../config';


	export default {
		name: 'FlightsAppBar',

		/* >>> *************************************************************** / /* Components */
		components: {

            'sdr-flights-appbar-filtermenue': FilterMenue,
            'sdr-flights-appbar-datemenue': DateMenue,
            'sdr-flights-reports-menue': ReportsMenue,
            FlightsCoreExplanation: () => import('./Explanation')

		}, // eo components{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Props */
        props: {

            value: {
                type: Boolean,
                default: false
            }

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                CONF_DAYS_BACKWARD_LONG,
                CONF_DAYS_BACKWARD_SHORT,
                CONF_DAYS_FORWARD_LONG,
                CONF_DAYS_FORWARD_SHORT,
                // -------------------------------------------------------------
                legOrFlightNo: '',
                zoomLevel: 2,
                showTooltip: true,
                fixFlightToAircraft: true,
                timeForewardBackwardDisabled: false
                // >>> ---------------------------------------------------------
            };

        }, // eo funtion data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_AircraftConfigs',
                'get_flights_StartDate',
                'get_flights_EndDate',
                'get_shared_Drawer'
            ])

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/core/AppBar.vue >>> created');
            eventBus.$on('calibratezoomlevel', me.onEmit_CalibrateZoomLevel);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/core/AppBar.vue >>> destroyed');
            eventBus.$off('calibratezoomlevel', me.onEmit_CalibrateZoomLevel);

        }, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setFlightsSchedulerPreset',
                'actn_set_Drawer',
                'actn_setCalendarDates'
            ]),


            /******************************************************************* 'Listeners - Emit'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
			* onClick_dateBackwardsLong()
			*
			* Desc: Emit Event for going backwards in date range.
            * Note:
            *
			*/
            onClick_dateBackwardsLong: function() {

                const me = this;


                me.$toc('>>> views/flights/components/core/AppBar.vue >>> onClick_dateBackwardsLong');
                eventBus.$emit('datebackwards', CONF_DAYS_BACKWARD_LONG);

            }, // eo function onClick_dateBackwardsLong


            /*******************************************************************
			* onClick_dateBackwardsShort()
			*
			* Desc: Emit Event for going backwards in date range.
            * Note:
            *
			*/
            onClick_dateBackwardsShort: function() {

                const me = this;


                me.$toc('>>> views/flights/components/core/AppBar.vue >>> onClick_dateBackwardsShort');
                eventBus.$emit('datebackwards', CONF_DAYS_BACKWARD_SHORT);

            }, // eo function onClick_dateBackwardsShort


            /*******************************************************************
			* onClick_dateForwardsLong()
			*
			* Desc: Emit Event for going backwards in date range.
            * Note:
            *
			*/
            onClick_dateForwardsLong: function() {

                const me = this;


                me.$toc('>>> views/flights/components/core/AppBar.vue >>> onClick_dateForwardsLong');
                eventBus.$emit('dateforwards', CONF_DAYS_FORWARD_LONG);

            }, // eo function onClick_dateForwardsLong


            /*******************************************************************
			* onClick_dateForwardsShort()
			*
			* Desc: Emit Event for going backwards in date range.
            * Note:
            *
			*/
            onClick_dateForwardsShort: function() {

                const me = this;


                me.$toc('>>> views/flights/components/core/AppBar.vue >>> onClick_dateForwardsShort');
                eventBus.$emit('dateforwards', CONF_DAYS_FORWARD_SHORT);

            }, // eo function onClick_dateForwardsShort


            /*******************************************************************
			* onChange_TooltipSwitch()
			*
			* Desc: Emit Event for switching on/off tooltips on events.
            * Note:
            *
			*/
            onChange_TooltipSwitch: function(value) {

                const me = this;


                me.$toc('>>> views/flights/components/core/AppBar.vue >>> onChange_TooltipSwitch');
                eventBus.$emit('updatedeventtooltipfeature', value);

            }, // eo function onChange_TooltipSwitch()


            /*******************************************************************
			* onChange_TooltipFixFlightToAircraft()
			*
			* Desc: Emit Event for switching on/off tooltips on events.
            * Note:
            *
			*/
            onChange_TooltipFixFlightToAircraft: function(value) {

                const me = this;


                me.$toc('>>> views/flights/components/core/AppBar.vue >>> onChange_TooltipFixFlightToAircraft');
                eventBus.$emit('updatedeventeventdragfeature', value === true ? 'AIRCRAFT' : 'TIME');

            }, // eo function onChange_TooltipFixFlightToAircraft()


            /*******************************************************************
			* onInput_zoomSlider()
			*
			* Desc: Emit Event for going backwards in date range.
            * Note: SliderValue   View   ZoomLevel
            *       1             Small  12
            *       2             Normal 15
            *       3             Large  18
            *
            * @param {number} value (Slider value 1-3)
            *
			*/
            onInput_zoomSlider: function(value) {

                const me = this;


                me.$toc('>>> views/flights/components/core/AppBar.vue >>> onInput_zoomSlider');
                if (value === 1) {
                    me.actn_setFlightsSchedulerPreset('overviewPreset');
                } else if (value === 2) {
                    me.actn_setFlightsSchedulerPreset('dayPreset');
                } else if (value === 3) {
                    me.actn_setFlightsSchedulerPreset('hourPreset');
                }

            }, // eo function onInput_zoomSlider()

            /*******************************************************************
			* onEmit_CalibrateZoomLevel()
			*
			* Desc: Possible Presets: "dayPreset", "overviewPreset", "hourPreset"
            * Note: Sets the zoomLevel when preset get changed
            *
			*/
            onEmit_CalibrateZoomLevel: function(preset) {

                const me = this;


                me.$toc('>>> views/flights/components/core/AppBar.vue >>> onEmit_CalibrateZoomLevel');
                if (preset === 'overviewPreset') {

                    me.zoomLevel = 1;
                } else if (preset === 'dayPreset') {

                    me.zoomLevel = 2;
                } else if (preset === 'hourPreset') {

                    me.zoomLevel = 3;
                }

            }, // eo function onEmit_CalibrateZoomLevel()


            /*******************************************************************
			* onChange_filterFlights()
			*
			* Desc: Emiting Event to filter Events.
            * Note: Approach: if there is a number in the string, it's the
            * Note: 'flightNo', otherwise it's the 'leg'.
            *
            * @param {string} value (Flight No of Leg for filtering Flights)
            *
			*/
            onChange_filterFlights: function(value) {

                const me = this;
                const payload = {};


                me.$toc('>>> views/flights/components/core/AppBar.vue >>> onChange_filterFlights');
                payload.type = /\d/.test(value) === true ? 'flightNo' : 'leg';
                payload.value = value.toUpperCase();

                eventBus.$emit('filtereventflightnoleg', payload); // emit ..

            }, // eo function onChange_filterFlights()


            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
			* isDateForwardBackwardDisabled()
			*
			* Desc: Compare Start and End Date.
            * Note: Date must be formatted, because they have different
            * Note: hours, minutes, seconds.
            *
            * @returns {boolean}
            *
			*/
            isDateForwardBackwardDisabled: function() {

                const me = this;
                const startDateFormatted = dayjs(me.get_flights_StartDate).format('YYYY-MM-DD'),
                    endDateFormatted = dayjs(me.get_flights_EndDate).format('YYYY-MM-DD');


                me.$toc('>>> views/flights/components/core/AppBar.vue >>> isDateForwardBackwardDisabled');
                return startDateFormatted !== endDateFormatted;

            }, // eo function isDateForwardBackwardDisabled()

            /*******************************************************************
			* onClick_refreshFlights()
			*
			* Desc: Refreshes the shown flights in scheduler
            * Note:
            *
            * @returns {boolean}
            *
			*/
            onClick_refreshFlights: function () {

                const me = this;
                let params = null,
                    dateRange = null,
                    invludeMVT = false;
                me.$toc('>>> views/flights/components/core/AppBar.vue >>> onClick_refreshFlights');

                if (dayjs().isBetween(me.get_flights_StartDate, me.get_flights_EndDate, 'day', '[]')) {
                    invludeMVT = true;
                }

                params = {
                    flightNo: null,
                    from: dayjs(me.get_flights_StartDate).format('YYYY-MM-DDT00:00:00[Z]'), //"2021-04-30T00:00:01Z"
                    fromAptCode: null,
                    idFlight: null,
                    to: dayjs(me.get_flights_EndDate).format('YYYY-MM-DDT23:59:59[Z]'),   //"2021-04-30T23:59:59Z"
                    toAptCode: null,
                    DOW: [],
                    idAircraftConfig: me.get_AircraftConfigs.map(aircraft => {
                        return aircraft.id;
                    }),
                    invludeMVT: invludeMVT
                };

                dateRange = {
                    startDate: dayjs(me.get_flights_StartDate),
                    endDate: dayjs(me.get_flights_EndDate)
                };

                me.menu = false;
                me.actn_setCalendarDates({ params, dateRange });

            } // eo function onClick_refreshFlights()

        } // eo methods
        /* <<< ****************************************************************/
	};
</script>

<style scoped>
	.theme--light.v-app-bar.v-toolbar.v-sheet {
		background-color: #FFFFFF;
		border-color: #FFFFFF;
		color: rgba(0, 0, 0, 0.87);
	}

	.v-toolbar__title {
		font-weight: 300;
		color: #555555;
		font-size: 18px;
		margin-bottom: 0px;
	}

	.theme--light.v-btn.v-btn--has-bg {
		background-color: #fff;
	}

    .v-label {
        font-size: 14px !important; /* 16px */
    }

    .sdr-custom-text-input input {
        text-transform: uppercase;
    }

</style>

<style>
    .sdr-custom-button-with-icon .v-icon::before {
        color: #AB3B7A;
    }

    .sdr-custom-button-with-icon.v-btn--disabled .v-icon::before {
        color: #e0e0e0;
    }

    .v-slider__tick, .v-slider__tick.v-slider__tick--filled {
        width: 7px !important;
        height: 7px !important;
        border-radius: 50%;
        margin-top: -3px;
        margin-left: -3px;
        background: #AB3B7A;
        cursor: pointer;
    }

    .v-slider__tick:first-of-type .v-slider__tick-label {
        transform: translateX(-50%) !important;
    }

    .v-slider__tick:last-of-type .v-slider__tick-label {
        transform: translateX(-25%) !important;
    }

    .theme--light.v-label {
		color: rgba(0, 0, 0, 0.7);
	}

    /* @media screen and (max-width: 1750px) {
        .header .v-toolbar__content div {
            margin-left: 0 !important;
        }
    } */
</style>
